import { render, staticRenderFns } from "./More.vue?vue&type=template&id=214b2043";
import script from "./More.vue?vue&type=script&lang=js";
export * from "./More.vue?vue&type=script&lang=js";
import style0 from "./More.vue?vue&type=style&index=0&id=214b2043&prod&lang=less";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;